import React from "react";

import HelpCircleIcon from "@uui/HelpCircle";
import InfoCircle from "@uui/InfoCircle";

import type { SvgIconProps } from "@mui/material";
import Stack from "@mui/material/Stack";
import styled from "@mui/material/styles/styled";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";

export type TooltipIconProps = Omit<TooltipProps, "children"> & {
  height?: React.CSSProperties["height"];
  iconColor?: React.CSSProperties["color"];
  Icon?: React.FunctionComponent<SvgIconProps>;
  variant?: "tooltip" | "help";
};

const ICON_BY_VARIANT = {
  tooltip: InfoCircle,
  help: HelpCircleIcon,
};

const StyledTooltip = styled(Tooltip)(({ theme }) => ({
  [theme.breakpoints.down("mobile")]: {
    display: "none",
  },
}));

const TooltipIcon = ({
  height = 14,
  iconColor,
  variant = "tooltip",
  Icon,
  ...tooltipProps
}: TooltipIconProps) => {
  const IconComponent = Icon ?? ICON_BY_VARIANT[variant];

  return (
    <StyledTooltip arrow placement="top" {...tooltipProps}>
      <Stack>
        <IconComponent
          sx={{
            height: `${height}px`,
            width: `${height}px`,
            color: iconColor ?? "shades.neutral.300",
          }}
        />
      </Stack>
    </StyledTooltip>
  );
};

export default TooltipIcon;
